import React from 'react';

function parseBold(line) {
  const parts = line.split(/\*\*(.+?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? <strong key={i}>{part}</strong> : part
  );
}

export default function TrainingTextSection({ section }) {
  const body = section?.textContent?.body || '';

  if (!body) return <div className="text-muted fst-italic">Sin contenido.</div>;

  const lines = body.split('\n');

  return (
    <div className="tts-body" style={{ lineHeight: '1.7', fontSize: '1rem', width: '100%', textAlign: 'justify' }}>
      {lines.map((line, i) => (
        <p key={i} style={{ margin: i < lines.length - 1 ? '0 0 0.5em' : 0 }}>
          {parseBold(line)}
        </p>
      ))}
    </div>
  );
}
